/* eslint-disable */
export default {
  loading: 'Laden...',
} as const;

// @key: @#@"loading"@#@ @source: @#@"Loading ..."@#@
